import { render, staticRenderFns } from "./TestimonialAdd.vue?vue&type=template&id=48999b8e"
import script from "./TestimonialAdd.vue?vue&type=script&lang=js"
export * from "./TestimonialAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports